import React from 'react';
import { Button, Popconfirm, Space } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { IShelfWithLocations } from '../../../../redux/api/inventory';

interface Props {
	shelf: IShelfWithLocations;
	canWrite: boolean;
	onEdit: (shelf: IShelfWithLocations) => void;
	onDelete: (shelf: IShelfWithLocations) => void;
	onPermissionDenied: () => void;
}

/** Edit/delete buttons shown on the right of each shelf. */
const ShelfActions: React.FC<Props> = ({ shelf, canWrite, onEdit, onDelete, onPermissionDenied }) => (
	<Space size={4}>
		<Button
			size="small"
			icon={<EditOutlined />}
			onClick={() => (canWrite ? onEdit(shelf) : onPermissionDenied())}
		/>
		<Popconfirm
			title="Delete this shelf?"
			onConfirm={() => onDelete(shelf)}
			disabled={!canWrite}
		>
			<Button
				size="small"
				danger
				icon={<DeleteOutlined />}
				onClick={!canWrite ? onPermissionDenied : undefined}
			/>
		</Popconfirm>
	</Space>
);

export default ShelfActions;
